import { render } from "./FrameFormDesigner-bak.vue?vue&type=template&id=249e9395&scoped=true"
import script from "./FrameFormDesigner-bak.vue?vue&type=script&lang=js"
export * from "./FrameFormDesigner-bak.vue?vue&type=script&lang=js"

import "./FrameFormDesigner-bak.vue?vue&type=style&index=0&id=249e9395&scoped=true&lang=less"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-249e9395"]])

export default __exports__